import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Define the translations with languages side by side
// "": ["",""]
const translations = {
  // NAVIGATION
  Home: ["Home", "الرئيسية"],
  MyAppointments: ["My Appointments", "مواعيدي"],
  AdminDashboard: ["Admin Dashboard", "لوحة التحكم"],
  AdminLogin: ["Admin Login", "تسجيل الدخول للمسؤول"],
  Logout: ["Logout", "تسجيل خروج"],
  Manzely: ["Manzely", "كشف منزلي"],

  // COMMON
  Doctor: ["Doctor", "الطبيب"],
  DoctorHomeVisit: ["Doctor Home Visit", "زيارة الطبيب المنزلية"],
  SignIn: ["Sign In", "تسجيل الدخول"],
  ForgotPassword: ["Forgot Password?", "نسيت كلمة المرور؟"],
  ResetPassword: ["Reset Password", "إعادة تعيين كلمة المرور"],
  SendResetLink: ["Send Reset Link", "إرسال رابط إعادة التعيين"],
  Age: ["Age", "العمر"],
  Gender: ["Gender", "النوع"],
  Phone: ["Phone", "رقم الهاتف"],
  Name: ["Name", "الاسم"],
  FullName: ["Full Name", "الاسم الكامل"],
  Email: ["Email address", "البريد الإلكتروني"],
  Password: ["Password", "كلمة المرور"],
  Male: ["Male", "ذكر"],
  Female: ["Female", "أنثى"],
  Submit: ["Submit", "إرسال"],
  Cancel: ["Cancel", "إلغاء"],
  Confirm: ["Confirm", "تأكيد"],
  Delete: ["Delete", "حذف"],
  Edit: ["Edit", "تعديل"],
  Close: ["Close", "إغلاق"],
  Details: ["Details", "التفاصيل"],
  Actions: ["Actions", "الإجراءات"],
  Date: ["Date", "التاريخ"],
  Status: ["Status", "الحالة"],
  SelectDate: ["Select Date", "اختر التاريخ"],
  SelectTime: ["Select Available Time", "اختر الوقت المتاح"],
  Loading: ["Loading", "جاري التحميل"],
  Next: ["Next", "التالي"],
  Back: ["Back", "السابق"],
  SuccessSent: [
    "Success! Email has been sent",
    "تم بنجاح! تم إرسال البريد الإلكتروني",
  ],
  Error: ["Error", "خطأ"],
  Search: ["Search", "بحث"],
  Filter: ["Filter", "تصفية"],
  Refresh: ["Refresh Data", "تحديث البيانات"],
  Save: ["Save", "حفظ"],

  // PATIENT FORM
  DoctorVisitBooking: ["Doctor Home Visit Booking", "حجز زيارة طبيب منزلية"],
  PatientInformation: ["Patient Information", "معلومات المريض"],
  VisitInformation: ["Visit Information", "معلومات الزيارة"],
  LocationInformation: ["Location Information", "معلومات الموقع"],
  VisitType: ["Visit Type", "نوع الزيارة"],
  ScheduledVisit: ["Schedule a visit", "حجز زيارة مجدولة"],
  UrgentVisit: [
    "Urgent visit (as soon as possible)",
    "زيارة عاجلة (في أقرب وقت ممكن)",
  ],
  UseMyLocation: ["Use my current location", "استخدم موقعي الحالي"],
  LocationDetected: ["Location detected", "تم تحديد الموقع"],
  YourLocation: ["Your Location", "موقعك"],
  District: ["District", "المنطقة"],
  AddressDetails: ["Address Details", "تفاصيل العنوان"],
  AddressPlaceholder: [
    "Enter street name, building number, apartment, landmarks, etc.",
    "أدخل اسم الشارع، رقم المبنى، الشقة، المعالم، إلخ.",
  ],
  SelectDistrict: ["Select a district", "اختر منطقة"],
  PhonePlaceholder: ["e.g., 01234567890", "مثال: ٠١٢٣٤٥٦٧٨٩٠"],
  PhoneInvalid: [
    "Please enter a valid 11-digit phone number",
    "الرجاء إدخال رقم هاتف صحيح مكون من 11 رقم",
  ],
  CoordinatesText: ["Coordinates", "الإحداثيات"],
  BookHomeVisit: ["Book Home Visit", "حجز زيارة منزلية"],
  Submitting: ["Submitting...", "جاري الإرسال..."],
  SelectAll: ["Select All", "اختر الكل"],
  UnselectAll: ["Unselect All", "إلغاء اختيار الكل"],
  SelectGender: ["Select gender", "اختر النوع"],
  VisitDateVerification: [
    "To book a visit today chose Urgent visit as appointment date must be in the future",
    "لحجز زيارة اليوم، اختر زيارة عاجلة حيث يجب أن يكون موعد الزيارة في المستقبل",
  ],

  // BOOKING SUMMARY
  BookingComplete: ["Booking Complete", "اكتمل الحجز"],
  BookingSubmitted: [
    "Your doctor visit request has been submitted!",
    "تم تقديم طلب زيارة الطبيب!",
  ],
  WhatsAppSummary: [
    "You can send the below summary to our WhatsApp for faster processing:",
    "يمكنك إرسال الملخص أدناه إلى واتساب للمعالجة بشكل أسرع:",
  ],
  SendToWhatsApp: ["Confirm", "تأكيد الحجز"],
  BookAnother: ["Book Another Visit", "حجز زيارة أخرى"],

  // AVAILABILITY MANAGER
  ManageDoctorAvailability: ["Manage Doctor Availability", "إدارة توفر الطبيب"],
  ScheduledAvailability: [
    "Scheduled Availability Dates",
    "تواريخ التوفر المجدولة",
  ],
  SelectAvailableTimeSlots: [
    "Select Available Time Slots",
    "اختر فترات الوقت المتاحة",
  ],
  SaveAvailability: ["Save Availability", "حفظ التوفر"],
  Saving: ["Saving...", "جاري الحفظ..."],
  AvailableTimeSlots: ["Available Time Slots", "فترات الوقت المتاحة"],
  NoTimeSlotsSpecified: ["No time slots specified", "لم يتم تحديد فترات زمنية"],
  ConfirmDelete: ["Confirm Delete", "تأكيد الحذف"],
  DeleteAvailability: ["Delete Availability", "حذف التوفر"],
  DeleteConfirmation: [
    "Are you sure you want to delete availability for",
    "هل أنت متأكد أنك تريد حذف التوفر ليوم",
  ],
  CannotBeUndone: [
    "This action cannot be undone.",
    "لا يمكن التراجع عن هذا الإجراء.",
  ],
  NoAvailability: [
    "No availability dates have been scheduled yet.",
    "لم يتم جدولة تواريخ التوفر بعد.",
  ],

  // ADMIN DASHBOARD
  DoctorVisitAdmin: ["Doctor Visit Administration", "إدارة زيارة الطبيب"],
  ManageReservations: ["Manage Reservations", "إدارة الحجوزات"],
  ManageAvailability: ["Manage Availability", "إدارة التوفر"],
  FilterStatus: ["Filter by status", "تصفية حسب الحالة"],
  AllReservations: ["All Reservations", "جميع الحجوزات"],
  Patient: ["Patient", "المريض"],
  Contact: ["Contact", "الاتصال"],
  ScheduledFor: ["Scheduled For", "مجدول ليوم"],
  AsapText: ["As soon as possible", "في أقرب وقت ممكن"],
  Location: ["Location", "الموقع"],
  CurrentLocationGPS: ["Current Location (GPS)", "الموقع الحالي (GPS)"],
  MarkFulfilled: ["Mark Fulfilled", "تحديد كمكتمل"],
  Deny: ["Deny", "رفض"],
  ConfirmAction: ["Confirm Action", "تأكيد الإجراء"],
  NoReservationsFound: ["No reservations found", "لم يتم العثور على حجوزات"],

  // STATUS
  Pending: ["Pending", "قيد الانتظار"],
  Fulfilled: ["Fulfilled", "مكتمل"],
  Denied: ["Denied", "مرفوض"],
  Cancelled: ["Cancelled", "ملغي"],
  Urgent: ["Urgent", "عاجل"],
  Scheduled: ["Scheduled", "مجدول"],

  // MY APPOINTMENTS
  MyAppointmentsTitle: ["My Appointments", "مواعيدي"],
  EnterPhone: [
    "Enter your phone number to view your appointments",
    "أدخل رقم هاتفك لعرض مواعيدك",
  ],
  EnterPhoneHelp: [
    "Enter the phone number you used to book the appointment",
    "أدخل رقم الهاتف الذي استخدمته لحجز الموعد",
  ],
  FindAppointments: ["Find My Appointments", "البحث عن مواعيدي"],
  Searching: ["Searching...", "جاري البحث..."],
  AppointmentDetails: ["Appointment Details", "تفاصيل الموعد"],
  PatientInfo: ["Patient Information", "معلومات المريض"],
  AppointmentInfo: ["Appointment Information", "معلومات الموعد"],
  LocationInfo: ["Location Information", "معلومات الموقع"],
  LocationType: ["Location Type", "نوع الموقع"],
  GPSLocation: ["GPS Location", "موقع GPS"],
  ManualAddress: ["Manual Address", "عنوان يدوي"],
  GPSCoordinates: ["GPS Coordinates", "إحداثيات GPS"],
  RequestedOn: ["Requested On", "تم الطلب في"],
  NoAppointmentsFound: [
    "No appointments found for this phone number",
    "لم يتم العثور على مواعيد لهذا الرقم",
  ],
  VerifyPhone: [
    "Please verify the phone number or contact support if you believe this is an error",
    "يرجى التحقق من رقم الهاتف أو الاتصال بالدعم إذا كنت تعتقد أن هذا خطأ",
  ],

  // LOGIN
  AdminLoginTitle: ["Admin Login", "تسجيل دخول المسؤول"],
  SigningIn: ["Signing in...", "جاري تسجيل الدخول..."],
  LoginFailed: [
    "Login failed. Please check your credentials and try again.",
    "فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد الخاصة بك والمحاولة مرة أخرى.",
  ],
  NoAdminAccount: [
    "No admin account exists with this email.",
    "لا يوجد حساب مسؤول بهذا البريد الإلكتروني.",
  ],
  IncorrectPassword: [
    "Incorrect password. Please try again.",
    "كلمة مرور غير صحيحة. حاول مرة اخرى.",
  ],
  InvalidEmail: ["Invalid email format.", "تنسيق بريد إلكتروني غير صالح."],
  TooManyAttempts: [
    "Too many failed login attempts. Please try again later or reset your password.",
    "محاولات تسجيل دخول فاشلة كثيرة. الرجاء المحاولة مرة أخرى لاحقًا أو إعادة تعيين كلمة المرور الخاصة بك.",
  ],
  NoAccount: [
    "No account exists with this email.",
    "لا يوجد حساب بهذا البريد الإلكتروني.",
  ],
  ResetSent: [
    "Password reset email has been sent. Check your inbox.",
    "تم إرسال بريد إلكتروني لإعادة تعيين كلمة المرور. تحقق من صندوق الوارد الخاص بك.",
  ],
  ResetFailed: [
    "Failed to send password reset email. Please try again.",
    "فشل في إرسال بريد إلكتروني لإعادة تعيين كلمة المرور. حاول مرة اخرى.",
  ],
  EnterAdminEmail: ["Enter your admin email", "أدخل البريد الإلكتروني للمسؤول"],

  // TIME SLOTS
  Time8To10: ["8:00 AM - 10:00 AM", "٨:٠٠ ص - ١٠:٠٠ ص"],
  Time10To12: ["10:00 AM - 12:00 PM", "١٠:٠٠ ص - ١٢:٠٠ م"],
  Time12To14: ["12:00 PM - 2:00 PM", "١٢:٠٠ م - ٢:٠٠ م"],
  Time14To16: ["2:00 PM - 4:00 PM", "٢:٠٠ م - ٤:٠٠ م"],
  Time16To18: ["4:00 PM - 6:00 PM", "٤:٠٠ م - ٦:٠٠ م"],
  Time18To20: ["6:00 PM - 8:00 PM", "٦:٠٠ م - ٨:٠٠ م"],
  Time20To22: ["8:00 PM - 10:00 PM", "٨:٠٠ م - ١٠:٠٠ م"],
  Time22To24: ["10:00 PM - 12:00 AM", "١٠:٠٠ م - ١٢:٠٠ ص"],
  Time0To2: ["12:00 AM - 2:00 AM", "١٢:٠٠ ص - ٢:٠٠ ص"],
  Time2To4: ["2:00 AM - 4:00 AM", "٢:٠٠ ص - ٤:٠٠ ص"],
  Time4To6: ["4:00 AM - 6:00 AM", "٤:٠٠ ص - ٦:٠٠ ص"],
  Time6To8: ["6:00 AM - 8:00 AM", "٦:٠٠ ص - ٨:٠٠ ص"],

  // MISC
  Step: ["Step", "الخطوة"],
  Of: ["of", "من"],
  SelectADate: ["Select a date", "اختر تاريخًا"],
  SelectATime: ["Select a time", "اختر وقتًا"],
  NoAppointmentSlots: [
    "No appointment slots are currently available. Please choose an urgent visit or check back later.",
    "لا توجد مواعيد متاحة حاليًا. يرجى اختيار زيارة عاجلة أو التحقق لاحقًا.",
  ],
  LoadingDates: [
    "Loading available dates...",
    "جاري تحميل التواريخ المتاحة...",
  ],
  LoadingAvailability: [
    "Loading availability data...",
    "جاري تحميل بيانات التوفر...",
  ],
  LoadingReservations: ["Loading reservations...", "جاري تحميل الحجوزات..."],
  DateFormat: ["en-US", "ar-EG"],
  Currency: ["EGP", "ج.م"],
  DoctorHomeVisitRequest: [
    "Doctor Home Visit Request",
    "طلب زيارة طبيب منزلية",
  ],
  "URGENT VISIT NEEDED": ["Urgent Visit Needed", "مطلوب زيارة عاجلة"],
  "Scheduled for": ["Scheduled for", "موعد الزيارة"],
  at: ["at", "التوقيت"],
  SameDayVisitUrgent: [
    "Same-day visits must be booked as urgent visits. Scheduling cannot be done on the same day.",
    "يجب حجز زيارات اليوم نفسه كزيارات عاجلة. لا يمكن جدولة الزيارات في نفس اليوم.",
  ],
};

// Function to transform translations into the format i18next expects
const transformTranslations = (translations) => {
  const resources = { en: { translation: {} }, ar: { translation: {} } };
  Object.keys(translations).forEach((key) => {
    resources.en.translation[key] = translations[key][0];
    resources.ar.translation[key] = translations[key][1];
  });
  return resources;
};

// Initialize i18next with the transformed translations
i18n.use(initReactI18next).init({
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  resources: transformTranslations(translations),
});

export default i18n;
